import styled from 'styled-components';
export const Container = styled.div `
  padding: var(--space-600);
  border-radius: var(--radius-brand);
  background: var(--bg-primary);
  border: 1px solid var(--border-secondary);
`;
export const Title = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #1a1a1a;
`;
export const Description = styled.div `
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin: 0 0 24px 0;

  p {
    margin: 0 0 12px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const SyncSection = styled.div `
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;
export const Footer = styled.div `
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e5e5e5;
  font-size: 14px;
  color: #666;
`;
